import ButtonSave from "../../UniversalEditModal/components/ButtonSave";
import BasicInfoSection from "./BasicInfoSection";
import RegionSelect from "./sections/RegionSelect";
import ExperienceSelect from "./sections/ExperienceSelect";
import UserEmailSection from "./sections/UserEmailSection";
import UserCallsignField from "./sections/UserCallsignField";
import UserAboutField from "./sections/UserAboutField";
import { RegionType } from "../../../types/EditModal/types";
interface Props {
    regions: RegionType[];
    hasUnsavedChanges: boolean;
}
export default function UserBasicInfo({ regions, hasUnsavedChanges }: Props) {
    return (
        <>
            <BasicInfoSection
                title="Основная информация"
                description="Расскажите о себе"
            >
                <UserCallsignField />

                <UserAboutField />
                <UserEmailSection />

                <RegionSelect regions={regions} />
                <ExperienceSelect />
            </BasicInfoSection>

            <ButtonSave hasUnsavedChanges={hasUnsavedChanges} />
        </>
    );
}
